<template>
  <div class="tickets">
    <MobileSidebarWrapper param="ticketId">
      <template slot="sidebar">
        <div class="sidebar">
          <div class="heading">
            <h1>{{ $ml.get(`Tickets`) }}</h1>
            <div class="button-wrapper">
              <app-btn @click="openModal">{{ $ml.get(`add ticket`) }}</app-btn>

            </div>
          </div>
          <aside>
            <div class="tabs-wrapper">
              <SidebarSwitcher
                :items="tabs"
                :value="getFilters.type"
                @input="selectType"
              />
            </div>
            <SearchInput
              v-model="search"
            />
            <nav>
              <SelectorOverlayContainer
                v-if="filtered.length"
                :value="$route.params.ticketId"
                :react-on="filtered"
              >
                <SelectorOverlayItem
                  v-for="item in filtered"
                  :key="item.id"
                  :class="{ is_active : (item.id === $route.params.ticketId) }"
                >
                  <TicketItem :item="item"/>
                </SelectorOverlayItem>
              </SelectorOverlayContainer>
            </nav>
          </aside>
        </div>
      </template>
      <template slot="content">
        <ticket/>
      </template>
    </MobileSidebarWrapper>
  </div>
</template>

<script>
  import MobileSidebarWrapper from '@/components/common/mobile-sidebar-wrapper/MobileSidebarWrapper'
  import {SelectorOverlayContainer, SelectorOverlayItem} from '@/components/common/selector-overlay'
  import InputLabel from "../../components/ui/InputLabel";
  import SidebarSwitcher from "../../components/common/SidebarSwitcher";
  import {mapGetters} from "vuex"
  import SearchInput from "../../components/common/SearchInput";
  import Ticket from "./Ticket";
  import TicketItem from "../../components/supports/TicketItem";

  export default {
    data() {
      return {
        tabs: [{
          key: 'all',
          label: this.$ml.get(`all`),
        },
          {
            key: 'opened',
            label: this.$ml.get(`opened`),
          }, {
            key: 'closed',
            label: this.$ml.get(`closed`),
          }],
        items: [],
        totalItems: [],
        page: 0,
        activeClass: 'all',
        search: ""
      }
    },

    created() {
      this.$store.dispatch('getTickets')
    },

    methods: {
      openModal() {
        this.$store.commit("openModal")
      },
      selectType(type) {
        this.$store.commit('setType', type);
      },
    },

    components: {
      TicketItem,
      Ticket,
      SearchInput,
      SidebarSwitcher,
      SelectorOverlayContainer,
      SelectorOverlayItem,
      MobileSidebarWrapper
    },
    watch: {

    },
    computed: {
      ...mapGetters({
        tickets: 'getTickets',
        getFilters: "getFilters",
      }),
      filtered() {
        if (this.search) {
          return this.tickets.filter(el => new RegExp(this.search, 'i').test(el.subject))
        }
        if (this.getFilters.type === "all") {
          return this.tickets
        } else
          return this.tickets.filter(el => el.status === this.getFilters.type);
      }

    }
  }
</script>

<style lang="scss" scoped>
  .tickets {
    aside {
      height: 100%;
      border: 1px #E4E5E6 solid;
    }

    .selector-overlay-container {
      margin-top: 20px;

      .selector-overlay-item {
        /*border-bottom: 1px solid rgba(76, 80, 86, 0.1);*/
        border-top: 1px solid rgba(76, 80, 86, 0.1);
        padding-top: 10px;
      }
    }

    .sidebar {
      height: 100%;
      display: flex;
      flex-direction: column;

      aside {
        height: 100%;
      }

      .sidebar-switcher {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding:0 0 10px;
      }

      .heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .list-item {
        .item {
          padding: 8px 20px;
          color: #2c3e50;
          display: flex;
          justify-content: space-between;
          transition: .3s;
          margin-bottom: 4px;

          span {
            font-weight: bold;
            font-size: 18px;
            z-index: 100;
          }

          .orange {
            text-transform: uppercase;
            font-style: normal;
            font-weight: bold;
            line-height: 12px;
            padding: 5px;
            background: #F2B14E;
            border-radius: 3px;
            display: block;
            font-size: 10px;

            &:not(.sub) {
              font-weight: bold;
              /*font-size: 16px;*/
            }
          }

          &.--selector-overlay-pointer {
            color: #fff;
          }
        }
      }
    }
  }

</style>
